import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {UserService} from "../service/user.service";
import {UserRole} from "../enums/UserRole";

export const isAuthenticatedAdminGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const token = userService.adminToken;
  const role = userService.role;
  if (role === UserRole.ADMIN && token !== '') {
    return true;
  }
  router.navigate(['/admin/login']);
  return false;
}
